/* `ht:review-sent` — THE QUEUE RE-READS WITHOUT A NAVIGATION (W82 step 4, Fable's F6 ruling): a review sent (or a reply
 * written under an exercise) changes what the Dashboard's queue, the review page's `‹ Review queue · n of m` and the
 * sidebar's count say; `useReviewQueue` — the ONE hook all three read — listens and reads again. The `ht:inbox-read`
 * pattern. The target is injectable so `reviewEvents.test.ts` runs it in Node. */

export const REVIEW_SENT = "ht:review-sent";

const defaultTarget = (): EventTarget | null => (typeof window === "undefined" ? null : window);

export function announceReviewSent(target: EventTarget | null = defaultTarget()): void {
  target?.dispatchEvent(new Event(REVIEW_SENT));
}

/** Listen; the returned function stops listening (an effect's cleanup). */
export function onReviewSent(fn: () => void, target: EventTarget | null = defaultTarget()): () => void {
  if (target === null) return () => {};
  target.addEventListener(REVIEW_SENT, fn);
  return () => target.removeEventListener(REVIEW_SENT, fn);
}
